<template>
    <ConfirmDangerModal ref="confirmDanger" />
</template>

<script>
import ConfirmDangerModal from '@/Components/Modals/ConfirmDangerModal.vue'
import { router } from '@inertiajs/vue3'

export default {
    name: 'ConfirmDeleteBaseModelModal',

    components: {
        ConfirmDangerModal,
    },

    expose: ['confirmDelete'],

    emits: ['delete', 'deleted'],

    props: {
        modelClass: {
            type: [String, null],
            required: true,
        },
        modelId: {
            type: [String, Number, null],
            required: true,
        },
        emitInsteadOfDelete: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        confirmDelete() {
            if (!this.modelClass || !this.modelId) {
                return
            }

            this.$refs.confirmDanger
                .confirm({
                    title: this.$lang.get('Delete :definitive_item_name', {
                        definitive_item_name: this.$getBaseModelTranslation({
                            modelName: this.modelClass,
                            wordClass: 'definitive',
                        }),
                    }),
                    body: this.$lang.get(
                        'Are you sure you want to delete :definitive_item_name?',
                        {
                            definitive_item_name: this.$getBaseModelTranslation(
                                {
                                    modelName: this.modelClass,
                                    wordClass: 'definitive',
                                }
                            ),
                        }
                    ),
                })
                .then((confirmed) => {
                    if (confirmed) {
                        if (this.emitInsteadOfDelete) {
                            this.$emit('delete', {
                                model_id: this.modelId,
                                model_class: this.modelClass,
                            })
                        } else {
                            router.delete(
                                this.$localizedRoute(
                                    `${this.modelClass}.destroy`,
                                    this.modelId
                                ),
                                {
                                    onFinish: () => {
                                        this.$emit('deleted')
                                    },
                                }
                            )
                        }
                    }
                })
        },
    },
}
</script>
